import * as z from "zod";

/** The signed-in user's Ask Redo chat for an email that was answered in chat. */
export const openAskRedoEmailRedirectChat = {
  name: "openAskRedoEmailRedirectChat" as const,
  input: z.object({ emailThreadId: z.string().min(1) }),
  output: z.object({ threadId: z.string() }),
};
